module.exports = __webpack_public_path__ + "img/gftz.431eca16.png";